const secondary = {
    social_bind_with: 'Already have an account? Sign in to link {{methods, list(type: disjunction;)}} with your social identity.',
};
export default Object.freeze(secondary);
